import type { IconType } from "@src/appV2/redesign/system/ui-components";
import type { IntentVariant } from "@src/appV2/redesign/system/ui-theme";

interface IntentConfig {
  intent?: IntentVariant;
  intentContent?: string;
  intentIcon?: IconType;
}

interface GetBottomSheetIntentParams {
  saveAttempted: boolean;
  errorMessage?: string;
  warningMessage?: string;
  infoMessage?: string;
}

/**
 * Determines the intent configuration for BottomSheetWithIntent based on validation state.
 * Prioritizes errors over warnings.
 */
export function getBottomSheetIntent(params: GetBottomSheetIntentParams): IntentConfig {
  const { saveAttempted, errorMessage, warningMessage, infoMessage } = params;

  const shouldShowError = saveAttempted && errorMessage;
  const shouldShowWarning = !shouldShowError && warningMessage;
  const shouldShowInfo = !shouldShowError && !shouldShowWarning && infoMessage;

  if (shouldShowError) {
    return {
      intent: "error",
      intentContent: errorMessage,
      intentIcon: "triangle-exclamation",
    };
  }

  if (shouldShowWarning) {
    return {
      intent: "warning",
      intentContent: warningMessage,
      intentIcon: "info",
    };
  }

  if (shouldShowInfo) {
    return {
      intent: "neutral",
      intentContent: infoMessage,
      intentIcon: "info",
    };
  }

  return {
    intent: undefined,
    intentContent: undefined,
    intentIcon: undefined,
  };
}
